import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Vue, Watch } from "vue-property-decorator";
import { CalendarHeatmap } from "vue-calendar-heatmap";
import LiquorTree from "liquor-tree";
import simplebar from "simplebar-vue";
import { interpret } from "xstate";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { ProjectModule } from "@/store/modules/project.module";
import projectAnalyticsMachine from "./machines/ProjectAnalyticsMachine";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import VueCarousel from "@/components/vueCarousel.vue";
import VueCarouselProjects from "@/components/vueCarouselProjects.vue";
import { RlCarouselSlide } from "vue-renderless-carousel";
import ProjectAnalyticsDetailsComponent from "../analytics/components/ProjectAnalyticsDetailsComponent.vue";
Vue.use(LiquorTree);
let ProjectAnalytics = /** @class */ (() => {
    let ProjectAnalytics = class ProjectAnalytics extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Project Analytics";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Analytics",
                    href: "#",
                },
                {
                    text: "Project",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.shadowProjectId = "";
            this.showListing = false;
            this.projectSearchFocus = false;
            this.searchCharacters = "";
            this.selectedFilter = "AccessibleToMe";
            this.selectedFilterForCarousel = "AccessibleToMe";
            this.selectedProjects = [];
            this.treeFilter1 = "";
            //   MACHINE
            this.machine = projectAnalyticsMachine.withContext({
                selectedFilters: "AccessibleToMe",
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
        }
        // public settings: any = {
        // 	dots: false,
        // 	infinite: true,
        // 	speed: 500,
        // 	slidesToShow: 3,
        // 	slidesToScroll: 1,
        // 	swipe: false,
        // 	adaptiveHeight: true,
        // 	responsive: [
        // 		{
        // 			breakpoint: 1400,
        // 			settings: {
        // 				slidesToShow: 2,
        // 				slidesToScroll: 1,
        // 				infinite: true,
        // 				dots: false,
        // 			},
        // 		},
        // 		{
        // 			breakpoint: 600,
        // 			settings: {
        // 				slidesToShow: 2,
        // 				slidesToScroll: 1,
        // 				initialSlide: 2,
        // 			},
        // 		},
        // 		{
        // 			breakpoint: 480,
        // 			settings: {
        // 				slidesToShow: 1,
        // 				slidesToScroll: 1,
        // 			},
        // 		},
        // 	],
        // };
        get treeOptions() {
            return {
                filter: {
                    emptyText: "No Results Found.",
                },
                propertyNames: {
                    text: "projectName",
                    children: "subProjects",
                },
            };
        }
        // Computed
        get projects() {
            return ProjectModule.projectAnalytics;
        }
        get filters() {
            const operationType = this.selectedFilter;
            const capitalizedWords = operationType.replace(/([A-Z])/g, " $1").trim();
            return capitalizedWords.charAt(0).toUpperCase() + capitalizedWords.slice(1);
        }
        get filteredProjects() {
            if (!this.treeFilter1) {
                return this.projects;
            }
            const filterText = this.treeFilter1.toLowerCase();
            return this.projects.reduce((filtered, project) => {
                this.collectMatchedProjects(project, filterText, filtered);
                return filtered;
            }, []);
        }
        // refreshes the tree
        projectAnalyticsChanged() {
            let theTree = this.$refs.tree;
            theTree.tree.setModel(this.filteredProjects);
        }
        // Methods
        selectProject(projectid) {
            this.projectId = projectid;
            this.shadowProjectId = "";
            let projectAnalyticsModal = this.$refs["projectAnalyticsRef"];
            projectAnalyticsModal.showModal(projectid);
        }
        handleNodeClick(node) {
            this.selectedProjects = [];
            if (this.treeFilter1 != "") {
                let theTree = this.$refs.tree;
                const visibleMatchesValue = theTree.matches.reverse();
                for (const projectNode of visibleMatchesValue) {
                    const projectId = projectNode.id;
                    const projectName = projectNode.data.text;
                    this.selectedProjects.push({ parentProjectId: projectId, parentProjectName: projectName, parentProjectCode: projectName });
                }
            }
            else {
                const nodeDepth = node.depth;
                if (nodeDepth != 0) {
                    const projects = node.parent.children;
                    for (const projectNode of projects) {
                        const projectId = projectNode.id;
                        const projectName = projectNode.data.text;
                        this.selectedProjects.push({ parentProjectId: projectId, parentProjectName: projectName, parentProjectCode: projectName });
                    }
                }
                else {
                    this.selectedProjects = this.projects.map((project) => {
                        return { parentProjectId: project.id.toString(), parentProjectName: project.projectName, parentProjectCode: project.code };
                    });
                }
            }
            this.selectProject(node.id);
        }
        applyFilter() {
            this.treeFilter1 = "";
            this.state.context.selectedFilters = this.selectedFilter;
            this.machineService.send({ type: "PROJECT_ANALYTICS_FILTERS" });
            this.selectedFilterForCarousel = this.filters;
        }
        clearFilter() {
            this.treeFilter1 = "";
            this.selectedFilter = "AccessibleToMe";
            this.state.context.selectedFilters = "AccessibleToMe";
            this.machineService.send({ type: "PROJECT_ANALYTICS_FILTERS" });
        }
        collectMatchedProjects(project, filterText, result) {
            if (project.name.toLowerCase().includes(filterText)) {
                result.push(project);
            }
            if (project.children && project.children.length > 0) {
                for (const child of project.children) {
                    this.collectMatchedProjects(child, filterText, result);
                }
            }
        }
        clearSearchCharacter() {
            this.treeFilter1 = "";
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Watch("projects"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Object)
    ], ProjectAnalytics.prototype, "projectAnalyticsChanged", null);
    ProjectAnalytics = __decorate([
        Component({
            name: "ProjectAnalytics",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
                CalendarHeatmap,
                SectionLoader,
                VueCarousel,
                VueCarouselProjects,
                RlCarouselSlide,
                ProjectAnalyticsDetailsComponent,
            },
        })
    ], ProjectAnalytics);
    return ProjectAnalytics;
})();
export default ProjectAnalytics;
